var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('el-row',[_c('el-col',{staticClass:"item1",attrs:{"span":5}},[_vm._v(" ")]),_c('el-col',{staticClass:"item1",attrs:{"span":14}},[(this.$route.path.indexOf('home') == -1)?_c('home-route-two'):_c('div',[_vm._v(" ")])],1),_c('el-col',{staticClass:"item3",attrs:{"span":5}},[_vm._v(" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }